export const banner = {
  items: [
    {
      title: 'banner.title',
      path: '/banner/list',
      icon: 'fa6-solid:flag'
    }
  ]
};
